import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import SL_Grid from '../../components/grid/SL_Grid';
import BatchFilters from './BatchFilters';
import { batchGridColumns } from './grid_columns/batch_grid_columns';
import PrintLabelsModal from '../../components/modals/PrintLabelsModal';
import { printBatchLabels } from '../../helpers/printLabels';
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages';
import { showErrorMessage } from '../../services/messages';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import Divider from '../../components/divider/Divider';

const ListBatches = () => {
  const navigate = useNavigate();
  const { setShowLoading } = useContext(GeneralContext);

  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  
  // Estados para o modal de impressão
  const [printModalVisible, setPrintModalVisible] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);

  useEffect(() => {
    loadBatches(filters);
  }, []);

  const loadBatches = async (filterParams = {}) => {
    setLoading(true);
    try {
      // Envia os filtros diretamente para o backend
      const response = await api.batch.list(filterParams);
      setBatches(response.data);
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_LOAD'));
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (values) => {
    setFilters(values);
    // Remove valores vazios, null ou undefined dos filtros antes de enviar
    const cleanedFilters = Object.keys(values).reduce((acc, key) => {
      const value = values[key];
      // Mantém apenas valores válidos (não vazios, não null, não undefined)
      if (value !== null && value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {});
    // Envia os filtros limpos para o backend
    loadBatches(cleanedFilters);
  };

  const handleClearFilters = () => {
    setFilters({});
    // Recarrega sem filtros
    loadBatches({});
  };

  const handleEdit = (record) => {
    navigate(`/batches/${record.id}`);
  };

  const handleCreate = () => {
    navigate('/batches/new');
  };

  const handleOpenPrintModal = (batch) => {
    setSelectedBatch(batch);
    setPrintModalVisible(true);
  };

  const handlePrint = async (quantity) => {
    if (selectedBatch) {
      await printBatchLabels(selectedBatch.id, quantity);
    }
  };

  const columns = batchGridColumns(handleEdit, handleOpenPrintModal);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card
        title={displayMessage('BATCHES')}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCreate}
          >
            {displayMessage('NEW_BATCH')}
          </Button>
        }
      >
        <BatchFilters onFilter={handleFilter} onClear={handleClearFilters} />
        
        <Divider />

        <SL_Grid
          dataSource={batches}
          columns={columns}
          loading={loading}
          rowKey="id"
        />
      </Card>

      {/* Modal de impressão de etiquetas */}
      <PrintLabelsModal
        visible={printModalVisible}
        onCancel={() => setPrintModalVisible(false)}
        onPrint={handlePrint}
        batchInfo={selectedBatch}
      />
    </div>
  );
};

export default ListBatches;

